export default {
  'pages.layouts.userLayout.title': 'こんにちは！',
  'pages.getCaptchaSecondText': '秒',
  'pages.workbench.link': 'ようこそ',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.announcement.status.draft': '下書き',
  'pages.announcement.status.scheduled': '予約公開',
  'pages.announcement.status.publishing': '公開中',
  'pages.announcement.status.published': '公開済み',
  'pages.announcement.status.publish_failed': '公開失敗',
  'pages.announcement.status.revoked': '取り消し済み',
  'pages.announcement.audience.memberLabel': '指定メンバー',
  'pages.announcement.audience.selectMembers': 'メンバーを選択してください',
  'pages.announcement.fields.status': '状態',
  'pages.announcement.fields.publishTime': '公開時間',
  'pages.announcement.fields.audience': '配信範囲',
  'pages.announcement.fields.summary': '概要',
  'pages.announcement.fields.revokeReason': '取り消し理由',
  'pages.announcement.fields.content': '本文',
  'pages.announcement.fields.attachments': '添付ファイル',
  'pages.announcement.admin.title': 'お知らせ管理',
  'pages.announcement.admin.columns.title': 'タイトル',
  'pages.announcement.admin.columns.creator': '作成者',
  'pages.announcement.admin.columns.publishTimeRange': '公開時間範囲',
  'pages.announcement.admin.columns.actions': '操作',
  'pages.announcement.admin.search.titlePlaceholder':
    'タイトルのキーワードを入力してください',
  'pages.announcement.admin.search.creatorPlaceholder':
    '作成者を入力してください',
  'pages.announcement.admin.pendingPublish': '公開待ち',
  'pages.announcement.admin.revokeReason': '管理画面で手動取り消し',
  'pages.announcement.admin.empty':
    'お知らせはまだありません。右上から最初のお知らせを作成してください。',
  'pages.announcement.admin.dispatchModalTitleWithName': '{title} の配信記録',
  'pages.announcement.detail.title': 'お知らせ詳細',
  'pages.announcement.detail.notFound': 'お知らせが存在しません',
  'pages.announcement.detail.backToList': '一覧に戻る',
  'pages.announcement.detail.edit': '編集',
  'pages.announcement.detail.revoke': '取り消し',
  'pages.announcement.detail.revokeReason': '詳細画面で手動取り消し',
  'pages.announcement.detail.revokeSuccess': 'お知らせを取り消しました',
  'pages.announcement.detail.dispatchRecords': '配信記録',
  'pages.announcement.create.title': 'お知らせ作成',
  'pages.announcement.create.scheduleSuccess':
    'お知らせの予約公開を設定しました',
  'pages.announcement.create.publishSuccess': 'お知らせの公開を送信しました',
  'pages.announcement.edit.title': 'お知らせ編集',
  'pages.announcement.edit.updateSuccess': 'お知らせを更新しました',
  'pages.announcement.form.statusReason':
    'このお知らせには状態の説明があります',
  'pages.announcement.form.title': 'タイトル',
  'pages.announcement.form.titlePlaceholder': 'タイトルを入力してください',
  'pages.announcement.form.titleRequired': 'タイトルを入力してください',
  'pages.announcement.form.summary': '概要',
  'pages.announcement.form.summaryPlaceholder':
    '概要を入力してください。カードでは概要が優先表示されます。',
  'pages.announcement.form.content': '本文',
  'pages.announcement.form.contentPlaceholder': '本文を入力してください',
  'pages.announcement.form.contentRequired': '本文を入力してください',
  'pages.announcement.form.pinned': '上部固定表示',
  'pages.announcement.form.pinnedOn': '固定',
  'pages.announcement.form.pinnedOff': '通常',
  'pages.announcement.form.publishMode': '公開時間',
  'pages.announcement.form.publishModeRequired': '公開タイプを選択してください',
  'pages.announcement.form.scheduledAt': '予約公開時間',
  'pages.announcement.form.scheduledAtRequired':
    '予約公開時間を選択してください',
  'pages.announcement.form.scheduledAtFuture':
    '予約公開時間は現在時刻より後である必要があります',
  'pages.announcement.form.audiences': '配信範囲',
  'pages.announcement.form.audiencesRequired':
    '少なくとも1つの配信範囲を追加してください',
  'pages.announcement.form.memberRequired': 'メンバーを選択してください',
  'pages.announcement.form.saveDraft': '下書きを保存',
  'pages.announcement.form.saveDraftSuccess': '下書きを保存しました',
  'pages.announcement.form.publishScheduled': '予約公開',
  'pages.announcement.form.publishNow': '今すぐ公開',
  'pages.announcement.form.submitTip':
    '下書き保存ではメッセージセンターは起動しません。今すぐ公開と予約公開はどちらもバックエンドのルールで処理されます。',
  'pages.announcement.form.cancel': 'キャンセル',
  'pages.announcement.center.title': 'お知らせセンター',
  'pages.announcement.center.columns.title': 'タイトル',
  'pages.announcement.center.columns.readStatus': '既読状態',
  'pages.announcement.center.columns.pinned': '固定表示',
  'pages.announcement.center.columns.organization': '公開組織',
  'pages.announcement.center.columns.attachmentStatus': '添付状態',
  'pages.announcement.center.search.titlePlaceholder':
    'タイトルのキーワードを入力してください',
  'pages.announcement.center.read.read': '既読',
  'pages.announcement.center.read.unread': '未読',
  'pages.announcement.center.boolean.yes': 'はい',
  'pages.announcement.center.boolean.no': 'いいえ',
  'pages.announcement.center.boolean.none': 'なし',
  'pages.announcement.center.attachment.has': '添付あり',
  'pages.announcement.center.attachment.none': '添付なし',
  'pages.announcement.center.emptySummary': '概要なし',
  'pages.announcement.center.viewDetail': '詳細を見る',
  'pages.announcement.center.empty': '閲覧可能なお知らせはありません',
  'pages.announcement.center.detail.title': 'お知らせ詳細',
  'pages.announcement.center.detail.backToCenter': 'お知らせセンターに戻る',
  'pages.announcement.center.detail.content': '本文',
  'pages.announcement.center.detail.loadFailed':
    'お知らせの読み込みに失敗しました',
  'pages.announcement.center.detail.retry': '再試行',
  'pages.announcement.permission.queryRequired':
    '現在のアカウントには照会権限がありません',
  'pages.announcement.dispatch.columns.type': '配信方式',
  'pages.announcement.dispatch.columns.status': 'メッセージセンター状態',
  'pages.announcement.dispatch.columns.errorMessage': '失敗理由',
  'pages.announcement.dispatch.columns.response': '応答概要',
  'pages.announcement.dispatch.status.pending': '処理中',
  'pages.announcement.dispatch.status.success': '成功',
  'pages.announcement.dispatch.status.failed': '失敗',
  'pages.announcement.dispatch.malformedResponse':
    '過去の応答サマリー形式が不正です',
  'pages.announcement.dispatch.expand': '展開',
  'pages.announcement.attachment.uploadSuccess':
    '{name} のアップロードに成功しました',
  'pages.announcement.attachment.uploadFailed':
    '添付ファイルのアップロードに失敗しました。もう一度お試しください。',
  'pages.announcement.attachment.fileTooLarge':
    '1つの添付ファイルは 20MB を超えることはできません',
  'pages.announcement.attachment.selectFiles': '添付ファイルを選択',
  'pages.announcement.attachment.empty': '添付ファイルはありません',
  'pages.announcement.attachment.delete': '削除',
  'pages.announcement.attachment.retry': '再試行',
  'pages.announcement.attachment.uploadCompleted': 'アップロード完了',
  'pages.announcement.attachment.missingFileKey':
    '添付ファイルに識別子がなく、現在はダウンロードできません',
  'pages.announcement.attachment.downloadUrlMissing':
    'バックエンドからダウンロード URL が返されませんでした',
  'pages.announcement.attachment.downloadFailed':
    'ダウンロード URL の取得に失敗しました',
  'pages.announcement.attachment.download': 'ダウンロード',
};
